import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "the-agency-dashboard",
  courseId: "for-agency-admins",
  order: 1,
  title: "Agency dashboard",
  summary:
    "/agency/dashboard is where you manage seats, officers, department-wide preferences, integrations, security policy, and retention.",
  learn: [
    "Sign in to the admin dashboard",
    "Read the seat cards and buy seats",
    "Find the right tab for each job",
  ],
  minutes: 3,
  releasedAt: "2025-06-01T00:00:00.000Z",
  gate: "admin",
  body: [
    {
      type: "paragraph",
      text: "Admins sign in separately at /agency/login. The dashboard header reads \"Agency Settings: {name}\". During a trial an \"Evaluation Period\" banner shows the end date. On first visit you are asked how many sworn officers you have, to size the department. Answer and click **Continue**.",
    },
    {
      type: "steps",
      items: [
        "Read the stat cards: Total Seats, Active Seats, Available Seats, Pending Invites, Reports Written, and the Subscription Information card.",
        "With no seats, click **Manage Seats** then **Purchase Seats** to set up the subscription.",
        "Open the tab you need. Officers is the default. The others are Report Preferences, Checklists, Snippets, Form Templates, Documents, Admins, Integrations, MFA, Data Retention, and Single Sign-On.",
        "On **Admins**, click **Invite Admins** to add a second admin so the department is not dependent on one login.",
      ],
    },
    {
      type: "bullets",
      items: [
        "Integrations: \"Axon Evidence\" credentials, **Test Connection**, **Save Configuration**. This turns on **Add Bodycam Video** for every officer.",
        "Data Retention: Delete Cases Upon Export (Move to Trash Bin or Permanently Delete), Automatically Delete Trashed Cases, Trash Retention Period, then **Save Settings**. Officers see the resulting \"Cases older than N days\" banner in their Trash.",
      ],
    },
    {
      type: "callout",
      tone: "note",
      title: "Admin and officer logins are separate",
      text: "An admin who also writes reports needs an officer account too, invited like anyone else.",
    },
    {
      type: "paragraph",
      text: "Invite officers is the first thing to do once seats are in place.",
    },
  ],
  related: ["invite-officers-and-roles", "department-preferences-templates-checklists", "seats-and-hour-packs"],
};

export default lesson;
